export const appRoles = {
  Admins: "USCP Application Repository-Admins",
};
